import { FunctionComponent, ReactElement, useContext } from 'react';
import styled from 'styled-components';
import CookiesLink from '../components/Cookies';
import { store } from '../store/store';
import { LinkCaption } from '../styles/LinkStyle';
import { Caption } from '../styles/TypoStyle';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  margin-top: 72px;
`;

const LinkContainer = styled.div`
  line-height: 40px;
  a:hover {
    text-decoration: none;
  }
`;

const FooterParagraph = styled(Caption)`
  margin-bottom: 16px;
`;

const ResponseCaptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
`;

interface displayProps {
  displayResponsePageCaption?: boolean;
  displayInsuranceCaption?: boolean;
  currentStep?: string;
}

export const FooterContainer: FunctionComponent<displayProps> = ({
  displayResponsePageCaption,
  displayInsuranceCaption,
  currentStep,
}): ReactElement => {
  const {
    state: { responseInfo },
    geoLoc,
  } = useContext(store);

  return (
    <Container>
      {displayResponsePageCaption && (
        <ResponseCaptionContainer id="response-caption">
          {responseInfo?.responsePageType !== 'IMMO' && geoLoc === 'CTLM' && (
            <FooterParagraph>
              Regroupement de crédits de 1500 € à 200 000 € consenti par BNP Paribas Personal Finance sous réserve
              d’étude et d’acceptation de votre dossier (hors projet professionnel ou immobilier). Durée de 13 à 180
              mois. La mensualité et le taux sont fixes et varient selon le montant et la durée du crédit. Vous disposez
              d’un délai légal de rétractation de 14 jours.
              <br />
              La baisse du montant des mensualités suppose un allongement de la durée de remboursement et une majoration
              du coût total des crédits objets du regroupement.
            </FooterParagraph>
          )}
          {responseInfo?.responsePageType !== 'CONSO' && geoLoc === 'CTLM' && (
            <FooterParagraph>
              Prêt immobilier consenti sous réserve d’étude et d’acceptation du dossier par le prêteur BNP Paribas
              Personal Finance. Vous disposez d’un délai de 10 jours de réception avant d’accepter l’offre de prêt. La
              vente immobilière est subordonnée à l’obtention du prêt nécessaire à son financement. A défaut, le vendeur
              est tenu de rembourser les sommes versées.
              <br />
              La baisse du montant des mensualités suppose un allongement de la durée de remboursement et une majoration
              du coût total des crédits objets du regroupement.
            </FooterParagraph>
          )}
          {geoLoc === 'CMAG' && (
            <FooterParagraph>
              Regroupement de crédits de 1500 € à 250 000 € consenti par Crédit Moderne Antilles Guyane sous réserve
              d'étude et d'acceptation de votre dossier (hors projet professionnel ou immobilier). Durée de 12 à 120
              mois. La mensualité et le taux sont fixes et varient selon le montant et la durée du crédit. Vous disposez
              d'un délai légal de rétractation de 14 jours.
              <br />
              La baisse du montant des mensualités suppose un allongement de la durée de remboursement et une majoration
              du coût total des crédits objets du regroupement.
            </FooterParagraph>
          )}
          {geoLoc === 'CMOI' && (
            <FooterParagraph>
              Regroupement de crédits de 1500 € à 250 000 € consenti par Crédit Moderne Océan Indien sous réserve
              d'étude et d'acceptation de votre dossier (hors projet professionnel ou immobilier). Durée de 12 à 120
              mois. La mensualité et le taux sont fixes et varient selon le montant et la durée du crédit. Vous disposez
              d'un délai légal de rétractation de 14 jours.
              <br />
              La baisse du montant des mensualités suppose un allongement de la durée de remboursement et une majoration
              du coût total des crédits objets du regroupement.
            </FooterParagraph>
          )}
        </ResponseCaptionContainer>
      )}
      {displayInsuranceCaption && (
        <ResponseCaptionContainer id="response-caption">
          <FooterParagraph id="footer-paragraph-1">
            *Toutefois, en fonction de votre situation, ou si le montant de votre financement est supérieur à 80.000€,
            vous devrez remplir un questionnaire de santé. Dans ce cas votre adhésion n’est possible qu’après étude du
            questionnaire de santé et acceptation de l’assureur.
          </FooterParagraph>
          <FooterParagraph id="footer-paragraph-1">
            * D : Décès <br />* I : Invalidité (Perte Totale et Irréversible d’Autonomie) <br />* M : Maladie
            (Incapacité Temporaire Totale de Travail) <br />* C : Chômage (Perte d’emploi suite à un licenciement)
          </FooterParagraph>
        </ResponseCaptionContainer>
      )}
      {geoLoc === 'CTLM' && (
        <>
          {currentStep === 'derniere-etape' && (
            <>
              <FooterParagraph>
                * Cetelem est une marque de BNP Paribas Personal Finance, Société Anonyme au capital de : 546 601 552
                euros. Siège social : 1 Boulevard Haussmann - 75009 Paris France. RCS : Paris N°542 097 902. N°ORIAS :
                07 023 128 (
                <LinkCaption target="_blank" href="https://www.orias.fr">
                  www.orias.fr
                </LinkCaption>
                ). Service clients N° Cristal : 09.69.36.55.63 (appel non surtaxé;). Du lundi au vendredi de 8h30 à 19h
                et le samedi de 9h à 16h.
              </FooterParagraph>
              <FooterParagraph>
                ** « CREDIT MARKET » est une marque de la société ASSU 2000 PARTICIPATIONS, SAS, mise à la disposition
                de la société ASC CREDITS, Intermédiaire en opérations de banque et services de paiement spécialisé en
                regroupement de crédits. ASC CREDITS appartient au groupe VILAVI. Dénomination sociale : ASC Crédits.
                Type de société : Société par Actions Simplifiée Adresse : 2 rue de Thessalie, LA CHAPELLE SUR ERDRE
                (44240) Numéro SIREN : 453 121 493 Assurance responsabilité civile : ALLIANZ IARD (Numéro 86850518-434)
                Capital social : 3.854.500 euros Téléphone : 05.35.37.11.88. ASC CREDITS est inscrite au registre unique
                des Intermédiaires tenu par ORIAS (
                <LinkCaption target="_blank" href="https://www.orias.fr">
                  www.orias.fr
                </LinkCaption>
                ) sous le numéro 07 006 221.
              </FooterParagraph>
              <FooterParagraph>
                *** FINVENS exploite EDDY, une marque appartenant à : NEED FOR LEADS - SASU au capital de 5 000 euros.
                8, rue John Fitzgerald Kennedy BP 10523 - 31005 Toulouse Cedex 6, RCS de Toulouse B 752483263, Siren
                Toulouse 752 483 263, représenté par Frédéric GRANEL en sa qualité de Président Directeur Général.
                Téléphone : 05.34.31.38.60, Mail :{' '}
                <LinkCaption href="mailto:contact@needforleads.fr">contact@needforleads.fr</LinkCaption>. Numéro TVA
                Intracommunautaire FR35752483263. Dénomination : FINVENS, Forme juridique : Société Anonyme Simplifiée
                unipersonnelle (SASU), Capital social : 351.184 euros, Siège social : 8, rue John Fitzgerald Kennedy BP
                10523 - 31005 Toulouse cédex 6 - RCS de : TOULOUSE, Numéro au RCS : 399 928 084, Code APE/NAF : 66 19 B,
                Courrier électronique : <LinkCaption href="mailto:contact@finvens.fr">contact@finvens.fr</LinkCaption> -
                Numéro au Registre des Intermédiaires : 07 004 179.
              </FooterParagraph>
              <FooterParagraph>
                **** Meilleurtaux, société par actions simplifiée au capital social de 1 000 000 euros - Siège social :
                36 rue de Saint-Pétersbourg 75008 Paris - Tél. : 01.86.27.27.00 - Fax : 01.86.27.27.91 - RCS Paris
                numéro 424 264 281 Sous le controle de l'ACPR, 4 place de Budapest 75436 Paris Cedex 09 (
                <LinkCaption target="_blank" href="https://www.acpr.banque-france.fr">
                  www.acpr.banque-france.fr
                </LinkCaption>
                ). Meilleurtaux SAS a souscrit une assurance responsabilité civile professionnelle auprès de MMA, 14
                Boulevard Marie et Alexandre Oyon - 72030 Le Mans CEDEX 9. Cette assurance couvre les sinistres survenus
                dans le monde entier. Meilleurtaux SAS est immatriculé au registre ORIAS sous le numéro 07 022 955 (
                <LinkCaption target="_blank" href="https://www.orias.fr">
                  www.orias.fr
                </LinkCaption>
                ).
              </FooterParagraph>
            </>
          )}
          <FooterParagraph id="footer-paragraph-1">
            Sous réserve d'étude et d'acceptation par BNP Paribas Personal Finance. BNP Paribas Personal Finance,
            Société Anonyme au capital de : 546 601 552€. Siège social : 1 Boulevard Haussmann - 75009 Paris France. RCS
            : Paris n° 542 097 902. N° ORIAS : 07 023 128 (
            <LinkCaption target="_blank" href="https://www.orias.fr">
              www.orias.fr
            </LinkCaption>
            ). Vous disposez d'un droit de rétractation.
          </FooterParagraph>
          <FooterParagraph id="footer-paragraph-2">
            Sauf indication contraire, les informations demandées sont obligatoires. Les données collectées sont
            destinées à BNP Paribas Personal Finance, responsable de traitement, et sont utilisées pour la gestion de
            votre demande, pour nous permettre de vous proposer des offres adaptées, ainsi que pour satisfaire à nos
            obligations légales et réglementaires. Pour plus d'informations sur le traitement de vos données
            personnelles et pour exercer vos droits : droit d'accès, de rectification, à l'effacement, à la limitation
            du traitement, à la portabilité des données, droit d'opposition (y compris à l'utilisation de vos données
            personnelles à des fins de prospection) et droit d'organiser la gestion de vos données après votre décès,
            vous pouvez nous contacter à l'adresse suivante : Service Consommateurs 95908 Cergy Pontoise Cedex 09 ou par
            e-mail à l'adresse consommateurdonneespersonnelles@bnpparibas-pf.com ou vous reportez à la notice{' '}
            <LinkCaption target="_blank" href={(window as unknown as WindowWithEnv)._env_.rgpdUrl}>
              Protection des données personnelles
            </LinkCaption>{' '}
            .
          </FooterParagraph>
          <FooterParagraph id="footer-paragraph-3">
            Il vous est possible de vous opposer à recevoir de la prospection commerciale par voie téléphonique en vous
            inscrivant gratuitement sur la liste d'opposition au démarchage téléphonique sur le site internet{' '}
            <LinkCaption target="_blank" href="https://www.bloctel.gouv.fr">
              www.bloctel.gouv.fr
            </LinkCaption>{' '}
            . Cette inscription interdit à un professionnel de vous démarcher téléphoniquement, sauf si cette
            sollicitation intervient dans le cadre de l'exécution d'un contrat en cours et qu'elle a un rapport avec
            l'objet de ce contrat.
          </FooterParagraph>
        </>
      )}
      {geoLoc === 'CMAG' && (
        <>
          <FooterParagraph id="footer-paragraph-1">
            Sous réserve d'étude et d'acceptation par Crédit Moderne Antilles Guyane, Société de financement -SA au
            capital de 18 727 232 € - Siège social : Le Sémaphore, ZAC Houelbourg Sud II, ZI Jarry, rue René Rabat,
            97122 Baie-Mahault - RCS Pointe-à-Pitre 341 891 653. N° ORIAS 07 027 944 (
            <LinkCaption target="_blank" href="https://www.orias.fr">
              www.orias.fr
            </LinkCaption>
            ). Vous disposez d'un droit de rétractation.
          </FooterParagraph>
          <FooterParagraph id="footer-paragraph-2">
            Sauf indication contraire, les informations demandées sont obligatoires. Les données collectées sont
            destinées à Crédit Moderne, responsable de traitement, et sont utilisées pour la gestion de votre demande,
            pour nous permettre de vous proposer des offres adaptées, ainsi que pour satisfaire à nos obligations
            légales et réglementaires. Pour plus d'informations sur le traitement de vos données personnelles et pour
            exercer vos droits : droit d'accès, de rectification, à l'effacement, à la limitation du traitement, à la
            portabilité des données, droit d'opposition (y compris à l'utilisation de vos données personnelles à des
            fins de prospection) et droit d'organiser la gestion de vos données après votre décès, vous pouvez nous
            contacter à l'adresse suivante : Service Consommateurs, ZI Les Mangles Acajou, 97 232 Le Lamentin.
          </FooterParagraph>
          <FooterParagraph id="footer-paragraph-3">
            Vous pouvez vous opposer sans frais à l’utilisation de vos données personnelles à des fins de prospection
            auprès de Crédit Moderne Antilles Guyane, Service Consommateurs, ZI Les Mangles Acajou, 97 232 Le Lamentin.
          </FooterParagraph>
        </>
      )}
      {geoLoc === 'CMOI' && (
        <>
          <FooterParagraph id="footer-paragraph-1">
            Sous réserve d'étude et d'acceptation par Crédit Moderne Océan Indien - Société de financement, SA au
            capital de 4 575 776 € - Siège social : 28, rue Lislet Geoffroy CS 91028, 97495 Ste Clotilde - RCS St Denis
            333 353 944 - N° Orias 07 029 039 (
            <LinkCaption target="_blank" href="https://www.orias.fr">
              www.orias.fr
            </LinkCaption>
            ). Vous disposez d'un droit de rétractation.
          </FooterParagraph>
          <FooterParagraph id="footer-paragraph-2">
            Sauf indication contraire, les informations demandées sont obligatoires. Les données collectées sont
            destinées à Crédit Moderne, responsable de traitement, et sont utilisées pour la gestion de votre demande,
            pour nous permettre de vous proposer des offres adaptées, ainsi que pour satisfaire à nos obligations
            légales et réglementaires. Pour plus d'informations sur le traitement de vos données personnelles et pour
            exercer vos droits : droit d'accès, de rectification, à l'effacement, à la limitation du traitement, à la
            portabilité des données, droit d'opposition (y compris à l'utilisation de vos données personnelles à des
            fins de prospection) et droit d'organiser la gestion de vos données après votre décès, vous pouvez nous
            contacter à l'adresse suivante : Service Consommateurs, 28 rue Lislet Geoffroy, 97495 Ste Clotilde.
          </FooterParagraph>
          <FooterParagraph id="footer-paragraph-3">
            Vous pouvez vous opposer sans frais à l’utilisation de vos données personnelles à des fins de prospection
            auprès de Crédit Moderne Océan Indien, Service Consommateurs, 28 rue Lislet Geoffroy, 97495 Ste Clotilde.
          </FooterParagraph>
        </>
      )}
      <LinkContainer>
        <CookiesLink />
      </LinkContainer>
    </Container>
  );
};
